/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S9_HeadingInputs */

const tr_iade_iptal_s9_heading = /** @type {(inputs: Iade_Iptal_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Fesih Bildirim Kanalları`)
};

const en_iade_iptal_s9_heading = /** @type {(inputs: Iade_Iptal_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Termination Notice Channels`)
};

const de_iade_iptal_s9_heading = /** @type {(inputs: Iade_Iptal_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Kanäle für die Beendigungsmitteilung`)
};

const ru_iade_iptal_s9_heading = /** @type {(inputs: Iade_Iptal_S9_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`9. Каналы уведомления о расторжении`)
};

/**
* | output |
* | --- |
* | "9. Termination Notice Channels" |
*
* @param {Iade_Iptal_S9_HeadingInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s9_heading = /** @type {((inputs?: Iade_Iptal_S9_HeadingInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S9_HeadingInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s9_heading(inputs)
	if (locale === "de") return de_iade_iptal_s9_heading(inputs)
	if (locale === "ru") return ru_iade_iptal_s9_heading(inputs)
	return tr_iade_iptal_s9_heading(inputs)
});